import React, { useState } from 'react';
import { IContent } from '../../../../types';
import { withContent } from '../../../../hoc/withContext';
import './AgeGateModal.scss';

import SelectFormElement from '../../../UI/Form/Select/SelectFormElement';

interface IModalAgeGateProps {
  context?: IContent;
  next: () => void;
  close: () => void;
}

const AgeGateModal = (props: IModalAgeGateProps) => {
  const { age_gate, global } = props.context;
  const { text, question, day, month, year } = age_gate;
  const { enter } = global;

  const [sentToValidation, setSentToValidation] = useState(false);
  const [tooYoung, setTooYoung] = useState(false);
  const [selectedDay, setSelectedDay] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');

  const currentDate = new Date();
  const startYear = currentDate.getFullYear() - 7;
  const maxAge = 73;

  const daysList = [];
  for (let i = 1; i <= 31; i++) {
    daysList.push(i.toString());
  }
  const monthsList = [];
  for (let j = 1; j <= 12; j++) {
    monthsList.push(j.toString());
  }
  const yearsList = [];
  for (let k = startYear; k >= startYear - maxAge; k--) {
    yearsList.push(k.toString());
  }

  const validateForm = () => {
    setTooYoung(false);
    setSentToValidation(true);
    if (selectedDay && selectedMonth && selectedYear) {
      const birthDate = new Date(parseInt(selectedYear), parseInt(selectedMonth) - 1, parseInt(selectedDay));
      let age = currentDate.getFullYear() - birthDate.getFullYear();
      const monthDiff = currentDate.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < birthDate.getDate())) {
        age--;
      }
      if (age >= 18) {
        localStorage.setItem("hasValidatedAgeGate", "true");
        props.next();
        props.close();
      } else {
        setTooYoung(true);
      }
    }
  };

  return (
    <div className="age_gate">
      <div className="info">
        <div className="block-title" dangerouslySetInnerHTML={{ __html: text }} />
        <div className="question" dangerouslySetInnerHTML={{ __html: question }} />
      </div>
      <div className="form">
        <SelectFormElement
          error={sentToValidation && (!selectedDay || tooYoung)}
          label={day}
          values={daysList}
          selectValue={setSelectedDay}
          required={true}

        />
        <SelectFormElement
          error={sentToValidation && (!selectedMonth || tooYoung)}
          label={month}
          values={monthsList}
          selectValue={setSelectedMonth}
          required={true}
        />
        <SelectFormElement
          error={sentToValidation && (!selectedYear || tooYoung)}
          label={year}
          values={yearsList}
          selectValue={setSelectedYear}
          required={true}
        />
      </div>
      <button
        className="store-outline"
        onClick={() => validateForm()}
        data-alt-text={enter}
      >
        <span>{enter}</span>
      </button>
    </div>
  );
};

export default withContent(AgeGateModal);
